import { AttacherSolver } from "@animech/supermodel";
import { getElementDragAndDropPayload } from "../../core/drag-and-drop";
import { CollisionSystem } from "../collision-system";
import { hasVectorProperties } from "./utility";
import {
	DropSceneObjectOperation,
	DropSceneObjectOperationInterface,
} from "./scene-object-drop-operation";
import { SceneObject } from "src/common";
import { ProductId } from "@definitions";

export type ProductIdPayload = {
	productId?: ProductId;
};

export function dropNewProductOperationFactory(
	element: HTMLElement,
	collisionSystem: CollisionSystem,
	globalAttacherSolver: AttacherSolver,
	dropOperationInterface: DropSceneObjectOperationInterface,
) {
	const payload = getElementDragAndDropPayload<ProductIdPayload>(element);
	if (!payload?.productId) {
		return undefined;
	}

	const { instantiateProduct } = dropOperationInterface;
	const object = instantiateProduct(payload.productId, true);
	const property = object.archetype;

	if (!hasVectorProperties(property, "position", "rotation")) {
		return undefined;
	}

	return new DropSceneObjectOperation({
		object,
		property,
		collisionSystem,
		globalAttacherSolver,
		dropOperationInterface,
		actionOnCancel: "delete-property",
		positionObjectPivotAtPointer: true,
	});
}

export function dragAndDropSceneObjectOperationFactory(
	object: SceneObject,
	collisionSystem: CollisionSystem,
	globalAttacherSolver: AttacherSolver,
	dropOperationInterface: DropSceneObjectOperationInterface,
) {
	const property = object.archetype;
	if (!property || !hasVectorProperties(property, "position", "rotation")) {
		return undefined;
	}

	return new DropSceneObjectOperation({
		object,
		property,
		collisionSystem,
		globalAttacherSolver,
		dropOperationInterface,
		actionOnCancel: "revert-position",
	});
}
